import React, { PureComponent } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from 'reactstrap'

class EnterNetlifyID extends PureComponent {
    
    constructor(props) {
        super(props);
    
        this.state = {
            netlifyID: '',
            confirmText: 'Link',
            cancelText: 'Cancel',
            cancelColor: 'secondary'
          };
        this.onQueryInput = this.onQueryInput.bind(this);
        this.onClickNetlify = this.onClickNetlify.bind(this);
    }

  componentDidUpdate() {
    this.setState({netlifyID: this.props.inputValue})
    if(this.props.inputValue !== "") this.setState({confirmText: "Update"})
    else this.setState({confirmText: "Link"})
  }

  onQueryInput(e) {
    this.setState({ netlifyID: e.target.value }, () => {this.props.onChange(this.state.netlifyID)} );
  }

  onClickNetlify() {
    this.props.onLinkNetlify()
    this.setState({ netlifyID: ""})
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.props.close}>Build Hook (Netlify ID)</ModalHeader>
        <ModalBody>
        <Input
            type='text'
            name='netlifyID'
            id='netlify-id-input'
            placeholder='Enter Build Hook (Netlify ID)'
            value={this.state.netlifyID}
            onChange={this.onQueryInput}

        />
        </ModalBody>
        <ModalFooter>
          <Button
            color={this.state.cancelColor}
            onClick={this.props.onClose}
            disabled={this.props.buttonsDisabled}
          >
            {this.state.cancelText}
          </Button>
          <Button
            color="primary"
            onClick={this.onClickNetlify}
            disabled={this.props.buttonsDisabled}
          >
            {this.state.confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}
export default EnterNetlifyID;


// WEBPACK FOOTER //
// ./src/views/Components/EnterNetlifyID.js